module.exports = __webpack_public_path__ + "img/logo.c329c5fe.png";